/**
 * Emotion styles of `/tax-exemption` (`components/TaxExemptionPage/index.tsx`). Wider than the
 * `lg` breakpoint both blocks are 70% wide with a 690 px minimum; otherwise full width.
 */
import { css } from "@emotion/react";
import { ITheme } from "@ryerson/frontend.theme";

/** The panel that holds the form. */
export const mainContainer = (theme: ITheme) => css`
	padding: 30px 258px 30px 42px;
	margin-left: 20px;
	background-color: ${theme.colors.secondary.background};
	width: 70%;
	min-width: 690px;
	margin-bottom: 90px;
	border-radius: 2px;
	@media only screen and (max-width: ${theme.breakpoints.lg}) {
		margin-left: 0px;
		padding: 10px 20px 60px 20px;
		width: 100%;
		min-width: 100%;
		border-radius: 0px;
	}
`;

/** The title and instruction block above the panel. */
export const titleContainerStyle = (theme: ITheme) => css`
	padding: 0px 24px 0px 20px;
	width: 70%;
	min-width: 690px;
	margin: 30px 0px 40px 0px;

	border-radius: 2px;
	@media only screen and (max-width: ${theme.breakpoints.lg}) {
		padding: 0px 20px 20px 0px;
		width: 100%;
		min-width: 100%;
		border-radius: 0px;
	}
`;
